export const stripHtmlTags = (html: string | undefined): string => {
  if (!html) return ''
  return html.replace(/<\/?[^>]+(>|$)/g, '').trim()
}
